module.exports = __webpack_public_path__ + "static/media/Lighthouse beams.45e53488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Lighthouse beams.svg
// module id = 79
// module chunks = 0